import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  FormGroup,
  FormControl,
  InputGroup,
  Glyphicon,
  DropdownButton,
  MenuItem,
  ButtonGroup,
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {
  get_employee_list,
  delete_user
} from "../../../redux/actions/subAdminActions";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import "../../../style/listPage.scss";
import {aclUtil} from "../../util"

const history = createBrowserHistory();
class UserList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'LIST_EMPLOYEE',
      userList: [],
      limit: 25,
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      path: ["Home", "Manage Employee"],
      links:["home", "userList"],
      show: false,
      emailSortIcon: "",
      firstNameSortIcon: "",
      lastNameSortIcon: "",
      userNameSortIcon: "",
      direction: "",
      orderBy: "",
      searchString: "",
      search: ""
    };
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }

    this.props.get_employee_list({ orderBy: orderBy, direction: direction,limit: this.state.limit });
  };

  handleSearch = () => e => {
    const searchString = e.target.value;
    if (searchString.length > 0) {
      this.props.get_employee_list({ search: searchString });
    } else {
      this.props.get_employee_list({ page: this.state.currentPage,limit: this.state.limit });
    }

    this.setState({ searchString: searchString });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentDidMount() {
    this.handleDismiss();
    this.props.clearAlert();
    this.props.get_employee_list({ page: this.state.currentPage,limit: this.state.limit });
  }
  handlePageChange = page => {
    this.setState({
      currentPage: page
    });
    if (this.state.direction !== "" && this.state.orderBy !== "") {
      this.props.get_employee_list({
        page: page,
        orderBy: this.state.orderBy,
        direction: this.state.direction,
        limit: this.state.limit
      });
    } else if (this.state.searchString !== "") {
      this.props.get_employee_list({ page: page, search: this.state.searchString, limit: this.state.limit });
    } else {
      this.props.get_employee_list({ page: page, limit: this.state.limit });
    }
  };

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.userList !== nextProps.userList) {
      if (nextProps.userList) {
        const setPageCount =
          nextProps.userList.total / nextProps.userList.per_page;
        this.setState({
          userList: nextProps.userList.data,
          totalRecords: nextProps.userList.total,
          perPage: nextProps.userList.per_page,
          pageCount: setPageCount
        });
      }
    }
    if (this.props.deletedUser !== nextProps.deletedUser) {
      if (nextProps.deletedUser) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.deletedUser.message);
      }
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  handleDelete = userID => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(userID);
        })
      ]
    });
  };

  confirmDelete = userID => {
    this.props.delete_user(userID);
    this.props.get_employee_list({ page: this.state.currentPage,limit: this.state.limit });
  };

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let userRow;
    if (!isEmpty(this.props.userList)) {
      userRow = this.props.userList.data.map((user, index) => (
        <tr key={user.user_id}>
          <td>{user.email}</td>
          <td>{user.userName}</td>
          <td>{user.firstName}</td>
          <td>{user.lastName}</td>
          <td>{user.UserTypeName}</td>
          <td>{user.status}</td>
          <td>
            <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL('VIEW_EMPLOYEE') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/userDetails/${user.user_id}`)}><i className="glyphicon glyphicon-eye-open"></i> View</MenuItem>):("")}
                  {aclUtil.checkACL('EDIT_EMPLOYEE') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/addSubAdmin/${user.user_id}`)}><i className="glyphicon glyphicon-pencil"></i> Edit</MenuItem>):("")}
                  {aclUtil.checkACL('DELETE_EMPLOYEE') ? (<MenuItem eventKey={Math.random()} onClick={this.handleDelete.bind(this, user.user_id)}><i className="glyphicon glyphicon-trash"></i> Delete</MenuItem>):("")}
                  {/*user.UserTypeName !== "salesmanager" ? (
                   <MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/acl/settings/${user.user_id}`)}><i className="glyphicon glyphicon-cog"></i> ACL</MenuItem>
                  ) : (
                    ""
                  )*/}
                   {user.UserTypeName == "salesmanager" ? (
                    <MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/cities/permission/${"edit"}/${user.user_id}`)}><i className="glyphicon glyphicon-cog"></i> Permission</MenuItem>
                   ) : (
                    ""
                 )}
                </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }

    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 user-list list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Employee List</header>

            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              {aclUtil.checkACL('ADD_EMPLOYEE') ? (
              <div className="col-lg-12 text-right">
                <Button
                  bsSize="small"
                  bsStyle="success"
                  onClick={() => this.context.router.history.push("/addSubAdmin")}
                >
                  + Add New User
                </Button>
              </div>):("")}
              <div className="clearfix" />
              <div className="row m-t-15">
                <div className="col-lg-4 pull-right">
                  <FormGroup>
                    <InputGroup>
                      <FormControl
                        type="text"
                        name="search"
                        onChange={this.handleSearch()}
                      />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
              </div>
              <div className="col-lg-12">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th onClick={this.handleSort("email")}>
                        Email<span
                          className={this.state.emailSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th onClick={this.handleSort("userName")}>
                        User Name<span
                          className={this.state.userNameSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th onClick={this.handleSort("firstName")}>
                        First Name<span
                          className={this.state.firstNameSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th onClick={this.handleSort("lastName")}>
                        Last Name<span
                          className={this.state.lastNameSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th>Type</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>{userRow}</tbody>
                </table>

                <div className="text-center">
                  <Pagination
                    total={totalRecords}
                    limit={perPage}
                    pageCount={5}
                    currentPage={currentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps
                    }) => (
                      <div className="pagination">
                        <button
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          first
                        </button>

                        {hasPreviousPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map(page => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666"
                            };
                          }
                          return (
                            <button
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          last
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UserList.propTypes = {
  get_employee_list: PropTypes.func.isRequired,
  delete_user: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  userList: state.subAdminReducer.userList,
  deletedUser: state.subAdminReducer.deletedUser,
  updatedUser: state.subAdminReducer.updatedUser,
  subAdminResponse: state.subAdminReducer.subAdminResponse,
  error: state.subAdminReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default withRouter(connect(mapStateToProps, {
  get_employee_list,
  delete_user,
  renderAlert,
  clearAlert
})(UserList));



// WEBPACK FOOTER //
// ./src/app/views/admin/subAdmin/UserList.js